require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./josephine-county-secure-treatment.json") })
        }
      }, "path---josephine-county-secure-treatment");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---josephine-county-secure-treatment!./.cache/json/josephine-county-secure-treatment.json
// module id = 914
// module chunks = 231608221292675